<template>
  <v-app>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <v-container fluid>
              <!--              <v-card elevation="2" outlined>-->
              <v-card-title>
                <!--                                    v-if="$can('transaction_create')"-->
                <v-btn
                  :to="{ name: 'notification.create' }"
                  class="btn-add-with-text"
                  v-status="'notification_create'"
                >
                  <v-icon>mdi-plus</v-icon>
                  افزودن
                </v-btn>
                <!--                  <v-spacer/>-->
                <!--                  {{ $t($route.meta.title) }}-->
                <!--                  <v-spacer/>-->
                <!--                  <v-btn :loading="loading" @click="reload"-->
                <!--                         class="btn-update">-->
                <!--                    <v-icon>mdi-refresh</v-icon>-->
                <!--                    به روزرسانی-->
                <!--                  </v-btn>-->
              </v-card-title>
              <v-divider />

              <div class="row">
                <div class="col-md-12 p-5">
                  <data-table
                    :data="data"
                    orderDir="desc"
                    :columns="columns"
                    class="p-2"
                    :debounce-delay="5000"
                    :translate="translate"
                    :per-page="[10, 25, 50, 100, 200, 400]"
                    @on-table-props-changed="reloadTable"
                  >
                  </data-table>
                </div>
              </div>

              <!--              </v-card>-->
            </v-container>
          </div>
        </div>
      </div>
    </div>
    <v-dialog
      transition="dialog-bottom-transition"
      max-width="600"
      v-model="dialog"
    >
      <template v-slot:default="dialog">
        <v-card>
          <v-toolbar color="primary" dark>
            <div class="text-h3 text-center">{{ item.title }}</div></v-toolbar
          >
          <v-card-text>
            <div class="text-h5 pt-5" v-html="item.text"></div>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn class="btn-cancel" @click="dialog.value = false">
              <span class="flaticon-cancel"></span>
              بستن
            </v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
  </v-app>
</template>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Button from "@/view/pages/Button";

export default {
  data() {
    return {
      loading: false,
      data: {},
      dialog: false,
      item: null,
      url: "notification",
      columns: [
        {
          name: "id",
          label: "شناسه",
          orderable: true,
        },
        {
          label: "عنوان",
          name: "title",
          orderable: true,
        },
        {
          name: "notify_type",
          label: "نوع اطلاع رسانی",
          orderable: true,
          transform: (value) => {
            return this.notifyType(value.data);
          },
        },
        {
          name: "user",
          label: "کاربر",
          transform: (value) => {
            return value.data.user.name;
          },
        },
        {
          name: "status",
          label: "وضعیت",
          orderable: true,
          transform: (value) => {
            return this.notifyStatus(value.data);
          },
        },
        {
          name: "extras",
          label: "اطلاعات زمان ارسال",
          orderable: true,
          transform: (value) => {
            return this.$options.filters.longDate(value.data.extras.notify_at);
          },
        },
        {
          name: "cost",
          label: "هزینه(ریال)",
          orderable: true,
          transform: (value) => {
            return value.data.cost !== null
              ? value.data.cost
              : "<span class='badge-success badge-pill'>رایگان </span>";
          },
        },
        {
          name: "count",
          label: "تعداد کاربران",
          orderable: true,
        },
        {
          name: "actions",
          label: "عملیات",
          component: Button,
          handler: this.actions,
          event: "action",
          meta: {
            permission_prefix: "notification_",
            buttons: [
              {
                name: "edit",
                label: "ویرایش",
                icon: "pencil-alt",
                class: "btn-edit",
              },
              {
                name: "delete",
                label: "حذف",
                icon: "trash",
                class: "btn-delete",
              },
              {
                name: "show",
                label: "نمایش",
                icon: "eye",
                class: "btn-show",
              },
            ],
          },
        },
      ],
      translate: {
        nextButton: "بعدی",
        previousButton: "قبلی",
        rowsPerPageText: "تعداد در صفحه",
        noDataText: "داده ای برای نمایش وجود ندارد",
        placeholderSearch: "جستجو",
      },
      tableProps: {
        search: "",
        length: 10,
        column: "id",
        dir: "desc",
      },
    };
  },
  methods: {
    reloadTable(tableProps) {
      this.getNotifications(this.url, tableProps);
    },
    getNotifications(url = this.url, query = this.tableProps) {
      this.loading = true;
      this.requestApiGet(url, query)
        .then((response) => {
          this.data = response.data.data;
          this.loading = false;
        })
        .catch((error) => {});
    },
    reload() {
      this.getNotifications(this.url, this.tableProps);
    },

    actions(data, type) {
      this[type](data);
    },

    show(data) {
      this.item = data;
      this.dialog = true;
    },
    edit(data) {
      this.$router.push({ name: "notification.edit", params: { id: data.id } });
    },

    delete(data) {
      let id = data.id;
      this.$swal({
        title: "حذف",
        text: "آیا از حذف این اطلاعیه اطمینان دارید؟",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "بله",
        cancelButtonText: "خیر",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.requestApiDelete(this.url + "/" + id)
            .then((response) => {
              this.reload();
            })
            .catch((error) => {});
        }
      });
    },

    notifyType(data) {
      if (data.notify_type === "email") {
        return "ایمیل";
      } else if (data.notify_type === "sms") {
        return "پیامک";
      } else if (data.notify_type === "notification") {
        return " اطلاع رسانی";
      } else if (data.notify_type === "push_notification") {
        return "اطلاع رسانی درون برنامه ای";
      }
    },

    notifyStatus(data) {
      if (data.status === "pending") {
        return "در انتظار";
      } else if (data.status === "sent") {
        return "ارسال شده";
      } else if (data.status === "denied") {
        return "ارسال نشده";
      } else if (data.status === "payed") {
        return "پرداخت شده";
      } else if (data.status === "approved") {
        return "تایید شده";
      }
    },
  },
  created() {
    this.getNotifications(this.url);
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.$t(this.$route.meta.title) },
    ]);
  },
};
</script>
